import React from 'react';
import { CONSTRAINT_TYPE_LABELS } from './PlanConstraintForm';
import type { PlanConstraintType } from './types';

/** Human label for a constraint type (falls back to the raw code for unknown types). */
export const PlanConstraintTypeLabel: React.FC<{ type: string }> = ({ type }) => (
  <>{CONSTRAINT_TYPE_LABELS[type as PlanConstraintType] ?? type}</>
);
